import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnModel, ColumnType } from '@ipensii/shared/domain-shared';
import { ObjectUtils } from '@ipensii/shared/util-shared';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { RippleModule } from 'primeng/ripple';
import { RequiredValueValidator } from '../validators/required-value.validator';

@Component({
  selector: 'ip-shared-list-column-edit',
  standalone: true,
  imports: [CommonModule, InputTextModule, FormsModule, CheckboxModule, RippleModule, RequiredValueValidator],
  templateUrl: 'list-column-edit.component.html',
})
export class ListColumnEditComponent<D> {
  @Input({ required: true }) column!: ColumnModel;
  @Input({ required: true }) data!: D;
  @Input() required = false;
  @Input() readonly = false;
  @HostBinding('class') readonly hostClasses = 'contents';
  protected readonly ObjectUtils = ObjectUtils;
  protected readonly ColumnType = ColumnType;
}
